import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

export interface OutboundPurpose {
  purpose: string
  label: string
  assistant_id: string
  /** False when the registry knows about the purpose but no VAPI assistant
   *  has been provisioned for it yet — UI should grey out un-configured
   *  purposes in the staging picker so the dial endpoint can't 400. */
  configured: boolean
}

export interface InboundReason {
  reason: string
  label: string
}

interface CallPurposesResponse {
  outbound: OutboundPurpose[]
  inbound_reasons: InboundReason[]
}

/** Single source of truth for the registry — populated from
 *  vapi-voice-agent/configs/call_purposes.json on the backend. The hook is
 *  cached aggressively because the registry is config-driven and changes
 *  rarely (it's not a frequent-update surface like /telemetry/calls). */
export function useCallPurposes() {
  return useQuery<CallPurposesResponse>({
    queryKey: ['call-purposes'],
    queryFn: () => apiFetch<CallPurposesResponse>('/vapi/call-purposes'),
    staleTime: 5 * 60_000,
  })
}
